// extracted by mini-css-extract-plugin
export default {"container":"ProfileDropdown_container__n4iWy"};